const RESOURCE_NAME = '/shipments-alerts-presets';
import restApi from "@/api/rest-api-object";

export default axios => ({
    ...restApi(axios, RESOURCE_NAME),

    triggerTypes(params) {
        return axios.get(`${RESOURCE_NAME}/trigger-types`, {params});
    }
});